import { AdminBadge } from '@interfaces/api/admin-badge'
import { axiosDelete } from '@services/api/axios'

export const apiAdminBadgeDelete = async (id: number) =>
  await axiosDelete<AdminBadge>(`/external-app-plugin/admin-badges/${id}`)
